import React from 'react'
import { createContentfulObject, contentfulTemplateMap } from '#src/services/contentful'
import { useContentfulByVariationQuery } from './Contentful.generated'
import { ContentfulData, ContentfulResult } from './types'
import isFunction from 'lodash/isFunction'

type ContentfulRenderFunction<TData extends ContentfulData> = (
  result: ContentfulResult<TData>
) => ReturnType<React.FC>

interface ContentfulProps {
  space?: string
  template: string
  variation: string
  children: ContentfulRenderFunction<any> | React.ReactElement
}

const ContentfulQuery: React.FC<ContentfulProps> = ({ space, template, variation, children }) => {
  let spaceId = space
  if (!spaceId) {
    spaceId = contentfulTemplateMap[template]
  }

  const { data, loading, error } = useContentfulByVariationQuery({
    variables: {
      template,
      variation,
      space: spaceId
    }
  })

  const content = data?.findContentByTemplate
    ? createContentfulObject(data.findContentByTemplate.entries)
    : undefined

  if (isFunction(children)) {
    return children({
      content,
      loading,
      error
    })
  } else if (content) {
    return React.cloneElement(children, {
      content
    })
  } else {
    return children
  }
}

export default ContentfulQuery
